
import Seo from '../../components/Seo';
export default function ClientDrivenPage() {
  
  const chk = (
    <svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg>
  );
  const dots = (
    <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
  );
  return (
    <>
      <Seo title="Client Work Productivity Analytics for Agencies & Consultancies | TeamGrid™" description="See how much of the week client firefighting takes, who is carrying too many accounts, and the effective rate each account really pays your agency." />
<header className="sect" style={{paddingBottom: '24px'}}>
  <div className="container">
    <div className="frow" style={{padding: '0'}}>
      <div>
        <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />Solutions › Client-Driven Work <span className="arr">›</span></span>
        <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '22px'}}>Great client service<br /><span style={{color: '#a9aab3'}}>that does not burn the team</span></h1>
        <p className="fd" style={{fontSize: '17px', lineHeight: '26px', color: 'var(--ink-soft)', marginBottom: '26px', maxWidth: '520px'}}>The account everyone answers in ten minutes is the account losing you money. Reactive work eats the day, the deliverable slips to the evening, and your best people quietly start looking. TeamGrid shows where responsiveness is costing more than it earns.</p>
        <ul className="hero-checks">
          <li>{chk}<span><b>Reactive vs. proactive split.</b> See how much of the week was firefighting.</span></li>
          <li>{chk}<span><b>Workload distribution.</b> Spot the person carrying three accounts alone.</span></li>
          <li>{chk}<span><b>Client profitability.</b> Real hours against real fees, per account.</span></li>
        </ul>
        <div className="hero-cta-row" style={{marginBottom: '0'}}>
          <a className="btn-primary" href="/register">Start free</a>
          <a className="btn-ghost" href="/book-demo">Get a demo for client teams →</a>
        </div>
      </div>
      <div className="frame">
        <div className="frame-h">{dots}ACCOUNT LOAD — THIS WEEK</div>
        <div className="applist" style={{padding: '16px 18px'}}>
          <span className="ap"><i style={{background: '#2DBDB8'}}></i>Northwind<span className="bar"><b style={{width: '46%', background: '#2DBDB8'}}></b></span><span className="pc">31h</span></span>
          <span className="ap"><i style={{background: '#F2673A'}}></i>Halcyon Group<span className="bar"><b style={{width: '93%', background: '#F2673A'}}></b></span><span className="pc">64h</span></span>
          <span className="ap"><i style={{background: '#469FD8'}}></i>Brightpath<span className="bar"><b style={{width: '54%', background: '#469FD8'}}></b></span><span className="pc">37h</span></span>
          <span className="ap"><i style={{background: '#8B75D7'}}></i>Ledgerline<span className="bar"><b style={{width: '38%', background: '#8B75D7'}}></b></span><span className="pc">26h</span></span>
        </div>
        <div className="sumcard" style={{borderTop: '1px solid var(--line-soft)'}}>
          <div className="sc-t">MARGIN FLAG — HALCYON GROUP</div>
          <p>Retainer covers 40h. Team logged <b>64h</b>, and <b>58%</b> of it was reactive. Two people absorbed the overflow after 6pm, four days running.</p>
        </div>
      </div>
    </div>
  </div>
</header>

<section className="sect" style={{paddingTop: '32px'}}>
  <div className="container">
    <h2 className="sect-h2">Responsiveness with<br /><span className="dim">the maths attached</span></h2>
    <p className="sect-sub">Built for agencies and consultancies where the client sets the tempo. No screenshots, no keystrokes, patterns not people.</p>

    <div className="frow">
      <div className="fr-copy">
        <span className="fl" style={{color: '#F2673A'}}>REACTIVE VS. PROACTIVE</span>
        <h3>How much of the week was firefighting?</h3>
        <p className="fd">TeamGrid splits the week into reactive work and planned work, then shows the interruptions that fragmented it. Teams that see the split usually take back a full day inside a month.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Reactive share tracked per account and per person</li>
          <li><span className="sarr">→</span>Interruption patterns that break deliverable focus</li>
          <li><span className="sarr">→</span>Protected blocks proposed from the real calendar</li>
        </ul>
      </div>
      <div className="frame">
        <div className="frame-h">{dots}WORK MIX — LAST 4 WEEKS</div>
        <div className="applist" style={{padding: '16px 18px'}}>
          <span className="ap">Week 1 proactive<span className="bar"><b style={{width: '38%', background: '#F2A73A'}}></b></span><span className="pc">38%</span></span>
          <span className="ap">Week 2 proactive<span className="bar"><b style={{width: '44%', background: '#F2A73A'}}></b></span><span className="pc">44%</span></span>
          <span className="ap">Week 3 proactive<span className="bar"><b style={{width: '51%', background: '#2DBDB8'}}></b></span><span className="pc">51%</span></span>
          <span className="ap">Week 4 proactive<span className="bar"><b style={{width: '58%', background: '#34A851'}}></b></span><span className="pc">58%</span></span>
        </div>
      </div>
    </div>

    <div className="frow rev">
      <div className="frame">
        <div className="frame-h">{dots}TEAM LOAD — CLIENT SERVICES</div>
        <div className="anlist">
          <div className="ancard"><span className="aico" style={{background: '#ffeceb'}}>▲</span><span><span className="at" style={{color: '#b3261e'}}>OVERLOADED</span><span className="am">Priya covers <b>3 accounts</b> and answered 41 after-hours threads this week.</span></span></div>
          <div className="ancard"><span className="aico" style={{background: '#e6f7f5'}}>=</span><span><span className="at" style={{color: '#007A6E'}}>BALANCED</span><span className="am">Four consultants sit within <b>8%</b> of the team median.</span></span></div>
          <div className="ancard"><span className="aico" style={{background: '#eef4fd'}}>◷</span><span><span className="at" style={{color: '#366EB6'}}>RESPONSE TIME</span><span className="am">Median first reply <b>34 min</b> — inside the promise on every account.</span></span></div>
        </div>
      </div>
      <div className="fr-copy">
        <span className="fl" style={{color: '#469FD8'}}>WORKLOAD &amp; RESPONSE</span>
        <h3>Find the person about to leave</h3>
        <p className="fd">Time spent on client tasks is visible per person, so an uneven load is caught in week two rather than at the exit interview. Response monitoring keeps the service promise honest at the same time.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Client hours distributed across the team, in view</li>
          <li><span className="sarr">→</span>After-hours creep flagged before it becomes normal</li>
          <li><span className="sarr">→</span>Response times tracked per account, not per inbox</li>
        </ul>
      </div>
    </div>

    <div className="frow">
      <div className="fr-copy">
        <span className="fl" style={{color: '#007A6E'}}>CLIENT PROFITABILITY</span>
        <h3>Which accounts actually pay</h3>
        <p className="fd">Hours land on clients automatically, so effective rate is current instead of reconstructed at quarter end. The scope conversation gets easier when it starts with numbers both sides can see.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Effective hourly rate per account, always current</li>
          <li><span className="sarr">→</span>Scope creep visible while it is still small</li>
          <li><span className="sarr">→</span>Renewal and repricing backed by real delivery data</li>
        </ul>
      </div>
      <div className="frame">
        <div className="frame-h">{dots}EFFECTIVE RATE BY ACCOUNT</div>
        <div className="applist" style={{padding: '16px 18px'}}>
          <span className="ap">Northwind<span className="bar"><b style={{width: '88%', background: '#34A851'}}></b></span><span className="pc">$186</span></span>
          <span className="ap">Brightpath<span className="bar"><b style={{width: '70%', background: '#2DBDB8'}}></b></span><span className="pc">$148</span></span>
          <span className="ap">Ledgerline<span className="bar"><b style={{width: '61%', background: '#469FD8'}}></b></span><span className="pc">$129</span></span>
          <span className="ap">Halcyon Group<span className="bar"><b style={{width: '34%', background: '#E0483D'}}></b></span><span className="pc">$72</span></span>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="sect" style={{paddingTop: '8px'}}>
  <div className="container">
    <div className="roi-cards" style={{marginTop: '0'}}>
      <div className="roi-card"><div className="rl">CLIENT SATISFACTION</div><div className="rv">+28%</div><p>Better scores when the promise matches the measured response.</p></div>
      <div className="roi-card"><div className="rl">PROACTIVE HOURS</div><div className="rv">+40%</div><p>More time on planned work instead of reacting to the inbox.</p></div>
      <div className="roi-card"><div className="rl">TURNOVER</div><div className="rv">−35%</div><p>Lower churn on client teams once load is shared evenly.</p></div>
      <div className="roi-card"><div className="rl">CLIENT MARGIN</div><div className="rv">+32%</div><p>Healthier margins when scope creep is priced, not absorbed.</p></div>
    </div>
    <p className="roi-note">*Typical results reported by TeamGrid agency and consultancy workspaces.</p>
  </div>
</section>

<div className="container"><div className="workswith"><span className="wl">WORKS BEST WITH</span><a href="/crm">CRM →</a><a href="/email-insights">Email Insights →</a></div></div>

<section className="sect" style={{padding: '8px 0 24px'}}>
  <div className="container">
    <h2 className="sect-h2" style={{fontSize: '28px', lineHeight: '36px'}}>Common questions</h2>
    <div className="faq">
      <details><summary>Does TeamGrid help manage client workload balance?</summary><p>Yes. It shows how time is distributed across client tasks and people, which makes it straightforward to rebalance accounts before someone is quietly carrying the whole book.</p></details>
      <details><summary>Can it improve focus on client deliverables?</summary><p>Yes. By showing interruptions and fragmented work patterns, TeamGrid points to where deliverable time is being lost, so protected blocks can be defended with evidence.</p></details>
      <details><summary>Is it suitable for consulting firms?</summary><p>Yes. Consultancies use it for workload distribution, productivity trends and client responsiveness, plus effective rate per account for renewal conversations.</p></details>
    </div>
  </div>
</section>

<section className="final" style={{paddingTop: '48px'}}>
  <div className="container-wide">
    <div className="final-band" style={{paddingBottom: '88px'}}>
      <h2>Serve clients better<br />and keep your people</h2>
      <a className="btn-white" href="/register">Get started FREE</a>
    </div>
  </div>
</section>
    </>
  );
}
